import React, { Component, PropTypes } from 'react';

// componenets
import Select from 'react-select';

//helpers
import { inlineCurrency3s } from 'components/Forms/validation';
import { preventTabDefault } from "./ingredientsSearchHelper";

const inputIds = {
    name: 'ingredientName',
    brand: 'brand',
    cpu: 'costPerUnit',
    unit: 'unit',
}
const textType = 'text';

export default class AddIngredient extends Component {
    static propTypes = {
        onNewCustomIngredientSave: PropTypes.func,
        cancelAddingNewIngredient: PropTypes.func,
        commonCustomUom: PropTypes.object,
        rowToFocus: PropTypes.number,
    };

    constructor(props) {
        super(props);
        this.state = {
            [inputIds.name]: { value: '', valid: true },
            [inputIds.brand]: { value: '', valid: true },
            [inputIds.cpu]: { value: '', valid: true },
            [inputIds.unit]: {},
        }
    }

    /**
     * State update on string change
     * @param {*} e event
     */
    onChange = e => {
        this.setState({
            [e.target.name]: {
                value: e.target.value,
                valid: true,
            },
        })
    }

    /**
     * State update on drop-down change
     * @param {*} e event
     */
    onDropDownChange = e => {
        this.setState({
            unit: { ...e, label: e.value },
        })
    }

    /**
     * On cost per unit blur
     * @param {*} e event
     */
    onCpuBlur = e => {
        const rawCpu = e.target.value;
        const isCpuValid = inlineCurrency3s(rawCpu);
        this.setState({
            costPerUnit: {
                value: isCpuValid ? rawCpu : '',
                valid: isCpuValid,
            }
        })
    }

    /**
     * on click save new ingredient
     */
    onNewCustomIngredientSave = () => {
        const { rowToFocus, onNewCustomIngredientSave } = this.props;
        const invalidObject = {
            value: '',
            valid: false,
        }
        let { ingredientName, brand, costPerUnit, unit } = this.state;
        if (!ingredientName.value.trim()) {
            ingredientName = { ...invalidObject };
        }
        if (!brand.value.trim()) {
            brand = { ...invalidObject }
        }
        if (!costPerUnit.value.trim()) {
            costPerUnit = { ...invalidObject }
        }
        if (ingredientName.valid && brand.valid && costPerUnit.valid) {

            const rowDataPrepared = {
                name: ingredientName.value.trim(),
                brand: brand.value.trim(),
                unit: unit.value || 'unknown',
                cost: costPerUnit.value.trim(),
                key: rowToFocus + 1
            }

            onNewCustomIngredientSave(rowDataPrepared);
        } else {
            this.setState({
                ingredientName,
                brand,
                costPerUnit
            })
        }
    }

    /**
     * renders the drop-down
     */
    renderDropDown = () => {
        const { commonCustomUom } = this.props;
        const { unit } = this.state;
        const unitOptions = commonCustomUom.map(item => ({
            value: item.get('abbreviation'),
            label: `${item.get('uomdesc')}(${item.get('abbreviation')})`,
        }));
        return (
            <Select
                classNamePrefix={'no-margin opt-left ss-dropdown'}
                options={unitOptions}
                menuPlacement='top'
                onChange={this.onDropDownChange}
                value={unit.value ? unit : null}
                placeholder='Unit'
                isSearchable={true}
                onKeyDown={preventTabDefault}
            />
        );
    }

    render() {
        const {
            ingredientName,
            brand,
            costPerUnit,
        } = this.state;
        const warningClassName = 'error-warning';

        return (
            <div className={'add-custom-row'} onKeyDown={e => e.stopPropagation()}>
                <div className={'adcust name-col'}>
                    <div className='ing-custom-input-wrapper'>
                        <input
                            type={textType}
                            placeholder='Ingredient Name'
                            name={inputIds.name}
                            className={ingredientName.valid ? null : warningClassName}
                            value={ingredientName.value}
                            onChange={this.onChange}
                            autoComplete={inputIds.name}
                        />
                    </div>
                </div>
                <div className={'adcust brand-col'}>
                    <div className='ing-custom-input-wrapper'>
                        <input
                            type={textType}
                            placeholder='Brand'
                            name={inputIds.brand}
                            className={brand.valid ? null : warningClassName}
                            value={brand.value}
                            onChange={this.onChange}
                            autoComplete={inputIds.brand}
                        />
                    </div>
                </div>
                <div className={'adcust cost-col'}>
                    <div className='ing-custom-input-wrapper'>
                        <input
                            type={textType}
                            placeholder='Cost Per Unit'
                            name={inputIds.cpu}
                            className={costPerUnit.valid ? null : warningClassName}
                            value={costPerUnit.value}
                            onBlur={this.onCpuBlur}
                            onChange={this.onChange}
                            autoComplete={inputIds.cpu}
                        />
                    </div>
                    {this.renderDropDown()}
                </div>
                <div className={'adcust action-col'}>
                    <div className='flex'>
                        <i
                            className='material-icons pointer mui--text-blue'
                            style={{ fontSize: '20px' }}
                            onMouseDown={() => this.onNewCustomIngredientSave()}
                        >done</i>
                        <i
                            className='material-icons pointer mui--text-blue'
                            style={{ fontSize: '20px', marginLeft: '5px' }}
                            onClick={() => this.props.cancelAddingNewIngredient()}
                        >close</i>
                    </div>
                </div>
            </div>
        )
    }
}
